module.exports = __webpack_public_path__ + "img/energifera-logo.aecd3e1f.png";